module.exports = __webpack_public_path__ + "static/b2-85308e6000bbcc6c4569847c258c175f.jpg";